<template>
    <div class='auth'>
        허용되지 않은 페이지 입니다.
    </div>
</template>

<script>
export default {
    name: 'Auth',
}
</script>

<style lang='scss'>
.auth {
    padding: 20vh 0;
    text-align: center;
}
</style>
